import { Outlet } from "react-router-dom";
import Sidebar from "./components/sidebar/Sidebar";
import AppBanner from "./components/appBanner/AppBanner";
import Header from "./components/header/Header";
import { Box } from "@mui/material";
import BottomNavigation from "./components/navigation/BottomNavigation";
import MobileNavigation from "./components/navigation/MobileNavigation";
import useResponsive from "./components/hooks/useResponsive";
import NavigationProvider from "./context/navigation/NavigationContext";
import GeoAuthGuard from "./components/GeoAuthGuard";

const App = () => {
  const { isSm } = useResponsive();

  return (
    <Box sx={{ maxWidth: "100vw" }}>
      <AppBanner />
      {/*<GeoAuthGuard>*/}
        <Header />
        <Sidebar>
          <Outlet />
        </Sidebar>
      {/*</GeoAuthGuard>*/}
      {!isSm && (
        <NavigationProvider>
          <MobileNavigation />
          <BottomNavigation />
        </NavigationProvider>
      )}
    </Box>
  );
};

export default App;
